import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasInputModule } from '../gas-input/gas-input.module';
import { GasDatepickerModule } from '../gas-datepicker/gas-datepicker.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasButtonModule } from '../gas-button/gas-button.module';
import {
  GasClickOutsideDirectiveModule,
} from '../../utils/click-outside-directive/gas-click-outside.module';

import { GasDatepickerInputComponent } from './gas-datepicker-input.component';
import { GasDatapickerCalendarComponent } from './gas-datapicker-calendar/gas-datapicker-calendar.component';
import { GasDatapickerCalendarDirective } from './gas-datapicker-calendar/gas-datapicker-calendar.directive';


const COMPONENTS = [
  GasDatepickerInputComponent,
  GasDatapickerCalendarComponent,
];
const DIRECTIVES = [
  GasDatapickerCalendarDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    GasDatapickerCalendarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    GasInputModule,
    GasDatepickerModule,
    GasIconsModule,
    GasButtonModule,
    ReactiveFormsModule,
    GasClickOutsideDirectiveModule,
  ],
})
export class GasDatepickerInputModule {
}
